import * as R from 'ramda';

import * as M from 'shared/types/models';

export const rangesHaveIntersection = R.curry((x: M.Range, y: M.Range) => {
  const rangesHaveNoIntersection = x.start > y.end || x.end < y.start;
  return !rangesHaveNoIntersection;
})
